import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import "./styles/main.css";

import ProtectedRoute from "./routes/ProtectedRoute";

import Library from "./pages/internal/Library";
import LayoutCaneva from "./layouts/LayoutCaneva";
import LayoutStream from "./layouts/LayoutStream";
import LayoutMinds from "./layouts/LayoutMinds";
import LayoutPulse from "./layouts/LayoutPulse";
import LayoutOrbit from "./layouts/LayoutOrbit";
import LayoutHome from "./layouts/LayoutHome";
import About from "./pages/public/About";
import LoginPage from "./pages/public/LoginPage";

import AccountPage from "./pages/masterpages/AccountPage";
import ProfilPage from "./pages/masterpages/ProfilPage";
import SettingPage from "./pages/masterpages/SettingPage";
import ProjectPage from "./pages/masterpages/ProjectPage";
import PricingPage from "./pages/masterpages/PricingPage";

const App = () => {
  return (
    <Router>
      <Routes>

        {/* Routes publiques */}
        <Route path="/login" element={<LoginPage />} />
        {/* <Route path="/about" element={<About />} /> */}

        {/* Route par défaut */}
        <Route path="/" element={<ProtectedRoute><LayoutHome /></ProtectedRoute>} />

        {/* Pages dashboard protégées */}
        <Route path="/Library" element={<ProtectedRoute><Library /></ProtectedRoute>} />
        <Route path="/HomePage" element={<ProtectedRoute><LayoutHome /></ProtectedRoute>} />
        <Route path="/caneva" element={<ProtectedRoute><LayoutCaneva /></ProtectedRoute>} />
        <Route path="/stream" element={<ProtectedRoute><LayoutStream /></ProtectedRoute>} />
        <Route path="/minds" element={<ProtectedRoute><LayoutMinds /></ProtectedRoute>} />
        <Route path="/pulse" element={<ProtectedRoute><LayoutPulse /></ProtectedRoute>} />
        <Route path="/orbit" element={<ProtectedRoute><LayoutOrbit /></ProtectedRoute>} />
        <Route path="/account" element={<ProtectedRoute><AccountPage /></ProtectedRoute>} />
        <Route path="/profil" element={<ProtectedRoute><ProfilPage /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><SettingPage /></ProtectedRoute>} />
        <Route path="/projects" element={<ProtectedRoute><ProjectPage /></ProtectedRoute>} />

        {/* Page 404 */}
        <Route path="*" element={<div>Page non trouvée</div>} />

      </Routes>
    </Router>
  );
};

export default App;